<template>
  <div class="code-dict-query">
    <NavHome class="faqNav" v-once/>
    <router-view v-wechat-title="$t($route.meta.title) + ' - ' + $t('app.name')"></router-view>
    <Footer style="padding-top: 10px;background-color: #fff;" />
  </div>
</template>

<script>
import NavHome from './layout/NavHome'
import Footer from './layout/Footer'

export default {
  name: 'ZMTariffQuery',
  components: { NavHome, Footer }
}
</script>
<style scoped>
  .code-dict-query >>> footer .wrap{
    width:1400px;
    padding-right: 17.5px;
  }
</style>




// WEBPACK FOOTER //
// src/components/ZMTariffQuery.vue